module.exports = __webpack_public_path__ + "img/NU.a576bb25.svg";